import { PersonStanding, X } from "lucide-react";
import BodyMap from "@/components/BodyMap";

export default function InjuriesSection({ injuries, onToggle }) {
  return (
    <section className="bg-white rounded-xl border border-slate-200 p-5 sm:p-6" data-testid="injuries-section">
      <h2 className="font-heading text-lg font-bold text-[#0F2547] flex items-center gap-2 mb-1">
        <PersonStanding className="h-5 w-5 text-[#005EB8]" /> Injuries — Body Map
      </h2>
      <p className="text-xs text-slate-500 mb-4">Tap a body part to mark an injury site. Tap again to remove it.</p>
      <div className="flex flex-col sm:flex-row gap-6 items-start">
        <BodyMap selected={injuries} onToggle={onToggle} />
        <div className="flex-1">
          <p className="text-xs font-semibold uppercase tracking-wider text-slate-400 mb-2">Marked injury sites</p>
          {injuries.length === 0 ? (
            <p className="text-sm text-slate-500" data-testid="no-injuries-message">No injuries marked on the body map.</p>
          ) : (
            <div className="flex flex-wrap gap-2" data-testid="injury-chips">
              {injuries.map((inj) => (
                <span key={inj} className="inline-flex items-center gap-1.5 bg-red-50 border border-red-200 text-[#D5281B] text-xs font-bold px-3 py-1.5 rounded-full">
                  {inj}
                  <button onClick={() => onToggle(inj)} data-testid={`remove-injury-${inj.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                    className="hover:text-[#991B1B] min-w-[24px] min-h-[24px] grid place-items-center" title={`Remove ${inj}`}>
                    <X className="h-3.5 w-3.5" />
                  </button>
                </span>
              ))}
            </div>
          )}
        </div>
      </div>
    </section>
  );
}
